import React, {Component} from "react";
import {Form, Steps, Button, Row, Col, Divider, message} from 'antd';
import NHFetch from '../../../../utils/NHFetch';
import PropTypes from "prop-types";
import style from '../index.css';
import FirstStep from './step-first';
import SeconedStep from './step-second';
import ThirdStep from './step-third';
import LastStep from './step-last';

const basicUrl = "/lcpz/"; //基础路径
const Step = Steps.Step;

/**
 * 流程配置编辑表单
 * Author: zengxiangkai@ly-sky.com
 * Created on: 2018-03-07 10:02:38
 * Version: 1.0
 * Modify log:
 */
class EditInitForm extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            isUpdate: false, //是否是更新操作
            current: 0, //当前步骤
            lcxxData: {}, //配置的流程信息
            hjxxData: [], //配置的环节信息
            isSuccess: false, //是否配置成功
        }
    }

    componentDidMount() {
        if (this.props.initFormData) {
            const initFormData = this.props.initFormData;
            const hjxxData = initFormData.lchjVOs;
            for (let key in hjxxData) {
                hjxxData[key].editable = true; //编辑模式
                hjxxData[key].yllchjid = [];
                hjxxData[key].yllchjmc = [];
                const ylhjVOs = hjxxData[key].ylhjVOs;
                for (let index in ylhjVOs) {
                    hjxxData[key].yllchjid.push(ylhjVOs[index].yllchjid);
                    hjxxData[key].yllchjmc.push(ylhjVOs[index].yllchjmc);
                }
            }
            this.setState({isUpdate: true, lcxxData: initFormData.lcdyVO, hjxxData: hjxxData})
        }
    }

    //下一步
    next = () => {
        const current = this.state.current + 1;
        if (this.state.current == 0) {
            //校验、缓存第一步的流程配置数据
            this.saveLcxx(current);
        } else if (this.state.current == 1) {
            //校验、缓存第二步的环节信息
            this.saveHjxx(current);
        } else {
            this.setState({current});
        }
    }

    //上一步
    prev = () => {
        const current = this.state.current - 1;
        this.setState({current});
    }

    //校验、缓存第一步的流程配置数据
    saveLcxx = (current) => {
        const lcxxForm = this.firstStepForm;
        lcxxForm.validateFields((err, formData) => {
            if (err) {
                return;
            }
            const {nd, zt} = formData;
            formData.zt = zt ? '1' : '0';
            formData.nd = new Number(nd).toString();
            this.setState({lcxxData: {...this.state.lcxxData, ...formData}});
            this.setState({current});
        });
    }

    saveHjxx = (current) => {
        if (this.state.hjxxData.length > 0) {
            const hjxxData = this.state.hjxxData.filter(item => item.hjid !== undefined && item.hjid != '');
            if (hjxxData.length <= 0) {
                message.error('请选择流程环节！');
            } else {
                this.setState({hjxxData: hjxxData});
                this.setState({current});
            }
        } else {
            this.setState({current});
        }
    }

    //流程配置信息改变时回调
    handleLcxxChange = (values) => {
        this.setState({lcxxData: {...this.state.lcxxData, ...values}});
    }

    //环节配置信息改变时回调
    handleHjxxChange = (hjxxData) => {
        this.setState({hjxxData: hjxxData});
    }

    //完成
    handleFinish = () => {
        let formData = {};
        formData = {lcxxMap: {...this.state.lcxxData}, hjxxList: [...this.state.hjxxData]};

        if (this.state.isUpdate) {
            NHFetch(basicUrl + 'update', 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data == 1) {
                            this.setState({isSuccess: true});
                        }
                        this.next();
                    }
                });
        } else {
            NHFetch(basicUrl + 'insert', 'POST', formData)
                .then(res => {
                    if (res) {
                        if (res.data == 1) {
                            this.setState({isSuccess: true});
                        }
                        this.next();
                    }
                });
        }

    }

    //是否继续添加（重新配置）
    handleReset = () => {
        this.setState({
            isUpdate: false, //是否是更新操作
            current: 0, //当前步骤
            lcxxData: {}, //配置的流程信息
            hjxxData: [], //配置的环节信息
            isSuccess: false, //是否配置成功
        });
    }

    //步骤一内容
    getFirstContent() {
        return <FirstStep ref={(form) => this.firstStepForm = form} onChange={this.handleLcxxChange}
                          initFormData={this.state.lcxxData}/>;
    }

    //步骤二内容
    getSecondContent() {
        return <SeconedStep data={this.state.hjxxData} onChange={this.handleHjxxChange}/>
    }

    //步骤三内容
    getThirdContent() {
        return <ThirdStep data={this.state.hjxxData} onChange={this.handleHjxxChange}/>
    }

    //最后一步内容
    getLastContent() {
        return <LastStep update={this.state.isUpdate} status={this.state.isSuccess} onReset={this.handleReset}/>
    }

    render() {

        const {form, initFormData} = this.props;
        const {current} = this.state;

        const steps = [{
            title: '流程定义',
            content: this.getFirstContent(),
            description: '说明：流程名称最好具有代表性，以免迎新流程太多时容易弄混。'
        }, {
            title: '环节设置',
            content: this.getSecondContent(),
            description: '说明：设置流程的环节，包括环节是否必须办理、是否是报到环节、是否允许打印报到单等。'
        }, {
            title: '环节关系设置',
            content: this.getThirdContent(),
            description: '说明：设置环节之间的前后依赖关系，即某环节的办理是否是以其他环节先办理为基础。'
        }, {
            title: '完成',
            content: this.getLastContent(),
        }];

        return (
            <div>
                <Row type="flex" justify="center">
                    <Col span={24}>
                        <Steps current={current}>
                            {steps.map(item => <Step key={item.title} title={item.title}/>)}
                        </Steps>
                        <div className={style["steps-content"]}>
                            {steps[this.state.current].content}
                        </div>
                        <div className={style["steps-action"]}>
                            {
                                this.state.current > 0 && this.state.current < steps.length - 1
                                &&
                                <Button style={{marginRight: 8}} onClick={this.prev}>
                                    上一步
                                </Button>
                            }
                            {
                                this.state.current < steps.length - 2
                                &&
                                <Button type="primary" style={{marginRight: 8}} onClick={this.next}>下一步</Button>
                            }
                            {
                                this.state.current === steps.length - 2
                                &&
                                <Button type="primary" onClick={this.handleFinish}>完成</Button>
                            }
                        </div>
                        {
                            this.state.current < steps.length - 1 ? <Divider/> : null
                        }
                        <div className={style["steps-description"]}>
                            <p>{steps[this.state.current].description}</p>
                        </div>
                    </Col>
                </Row>
            </div>
        );
    }
}

EditInitForm.propTypes = {
    initFormData: PropTypes.object, //初始数据
}

const EditForm = Form.create()(EditInitForm);

export default EditForm;


// WEBPACK FOOTER //
// ./components/lcgl/lcpz/edit-form/EditForm.js